


































































import Vue from "vue";
import AdminService from "@/services/adminService";
import TeamService from "@/services/getTeams";
import {TheTeam} from "@/models/the-team";

export default Vue.extend({
  name: "UpdateTeams",
  props: ["update_id", "update_name"],

  data() {
    let tmp: any;
    return {
      teams: [] as TheTeam[],
      file: tmp,
      uploading: false,
      isLoaded: false,
      name: "",
      lastname: "",
      title: "",
      email: "",
      mobile: "",
      certification: "",
      imgurl: "",
      group: "",

    };
  },
  async created() {
    await this.getList();
  },
  methods: {
    async getList() {
      this.isLoaded = true;
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        const teamService = new TeamService(jwt);
        const response = await teamService.getTeams();
        if (response && response.status == 200) {
          this.teams = response.data;

          const u = this.teams.find(value => {
            return value.id === this.$props.update_id;
          });

          this.name = u!.name;
          this.lastname = u!.lastname;
          this.title = u!.title;
          this.email = u!.email;
          this.mobile = u!.mobile;
          this.certification = u!.certification;
          this.imgurl = u!.imgurl;
          this.group = u!.group;

        }
      }
      this.isLoaded = false;
    },
    handleFileUpload() {
      const tmp = (this.$refs.file as HTMLInputElement).files;
      if (tmp && tmp.length) {
        this.file = tmp[0];
      }
    },
    async submit(e) {
      this.uploading = true;
      e.preventDefault();
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        try {
          const formData = new FormData();
          if(this.file != undefined) {
            formData.append("file", this.file);
          }
          formData.append("name", this.name);
          formData.append("lastname", this.lastname);
          formData.append("title", this.title);
          formData.append("email", this.email);
          formData.append("mobile", this.mobile);
          formData.append("certification", this.certification);
          formData.append("group", this.group);
          const adminService = new AdminService(jwt);
          const response = await adminService.updateTeams(formData);
          if (response && response.status == 200) {
            if (response.data) {
              this.uploading = false;
              alert("Update Successfully");
              await this.$router.push("/admin-teams");
            }
          }
        } catch (error) {
          this.uploading = false;
          alert(JSON.stringify(error.response.data));
        }
      }
    },
    async cancel() {
      await this.$router.push("/admin-teams");
    }
  }
});
